<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-15 17:46:32
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-31 16:46:02
-->
<template>
  <div class="guidance">
    <div class="guidance-wrap">
      <div class="guidance-box">
        <div v-show="activeName == 'business'" class="guidance-box-list">
          <div>
            <el-form ref="guidanceForm" :model="formData" :rules="formRules" class="ui-form" label-position="left">
              <el-form-item :label="$t('guidance.form.username.label')" prop="username">
                <el-input
                  ref="username"
                  v-model="formData.username"
                  name="username"
                  type="text"
                  tabindex="1"
                  maxlength="20"
                />
              </el-form-item>
              <el-form-item :label="$t('guidance.form.telephone.label')" prop="telephone">
                <el-input
                  ref="telephone"
                  v-model="formData.telephone"
                  name="telephone"
                  type="text"
                  tabindex="1"
                  maxlength="11"
                  @input="formData.telephone=formData.telephone.replace(/\D/g, '')"
                />
              </el-form-item>
              <el-form-item :label="$t('guidance.form.email.label')" prop="email">
                <el-input
                  ref="email"
                  v-model="formData.email"
                  name="email"
                  type="text"
                  tabindex="1"
                  maxlength="60"
                />
              </el-form-item>
              <el-form-item :label="$t('guidance.form.company.label')" prop="company">
                <el-input
                  ref="company"
                  v-model="formData.company"
                  name="company"
                  type="text"
                  tabindex="1"
                  maxlength="80"
                />
              </el-form-item>
              <el-form-item :label="$t('guidance.form.address.label')" prop="address">
                <el-input
                  ref="address"
                  v-model="formData.address"
                  name="address"
                  type="text"
                  tabindex="1"
                  maxlength="80"
                />
              </el-form-item>
              <el-form-item :label="$t('guidance.form.consult.label')" prop="consult">
                <el-input
                  ref="consult"
                  v-model="formData.consult"
                  name="consult"
                  type="textarea"
                  maxlength="100"
                  show-word-limit
                />
              </el-form-item>
              <div class="">
                <div class="guidance-form-btn disabled" @click="handleSubmit('guidanceForm')">{{$t('guidance.form.btn')}}</div>
              </div>
            </el-form>
          </div>
        </div>
        <div v-show="activeName == 'other'" class="guidance-box-list">
          <div class="guidance-cards" v-for="item, index in $t('guidance.cards')" :key="index">
            <p class="guidance-cards-label" v-html="item.label"></p>
            <p class="guidance-cards-des" v-html="item.des"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="guidance-tabs flex justify_content_center">
      <div :class="['guidance-tabs-item', activeName == 'business' ? 'active' : '']" @click="activeName = 'business'">{{$t('guidance.tab')[0]}}</div>
      <div :class="['guidance-tabs-item', activeName == 'other' ? 'active' : '']" @click="activeName = 'other'">{{$t('guidance.tab')[1]}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'business',
      formData: {
        username: '',
        telephone: '',
        email: '',
        company: '',
        address: '',
        consult: ''
      },
      formRules: {
        username: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        telephone: [
          { required: true, message: '请输入您的手机号码', trigger: 'blur' },
          { message: '电话号码格式有误！', pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        consult: [
          { required: true, message: '请输入咨询内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit (formName) {
      // console.log(111)
      // this.$refs[formName].validate(valid => {
      //   if (valid) {
      //     // 调用后台接口
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
    }
  }
}
</script>

<style lang="less">
@import "~@/styles/index.less";
.m {
  .guidance {
    .el-form-item {
      margin-bottom: 30px;
      .flex;
    }
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      content: "";
      margin-right: 0;
    }
    .el-form-item__content {
      line-height: 80px;
      .flex_1;
    }
    .el-input__inner {
      height: 80px;
      min-height: 80px;
      line-height: 80px;
      font-size: 28px;
    }
    .el-form-item__label{
      width: 5.2em;
      padding: 0;
      color: #333333;
      font-size: 28px;
      line-height: 80px;
      // background: red;
    }
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after {
        content: "*";
        width: 10px;
        color: #D11616;
        margin-left: 4px;
        margin-top: 10px;
    }
    .el-textarea__inner {
      height: 200px;
    }
  }
}
.m.en .guidance{
  .el-form-item {
    margin-bottom: 30px;
    display: block;
  }
  .el-form-item__label {
    width: 100%;
  }
}
</style>
<style lang="less" scoped>
.m {
  .guidance {
    position: relative;
    overflow: hidden;
    font-size: 26px;
    color: #333333;
    .guidance-wrap {
      padding: 160px 20px 136px 20px;
      background-image: url("~@/assets/images/guidance/m_bj.png");
      background-repeat: no-repeat;
      background-position: left top;
      background-size: 100% 100%;
      // height: calc(100vh - 300px);
    }
    .guidance-box {
      background: rgba(255, 255, 255, 0.89);
      box-shadow: 0px 8px 13px 1px rgba(0,136,226,0.13);
      border-radius: 25px;
      padding: 30px;
    }
    .guidance-tabs {
      width: 100%;
      height: 96px;
      position: absolute;
      bottom: -1px;
      .guidance-tabs-item {
        width: 50%;
        height: 100%;
        border: 1PX solid #B9B9B9;
        font-size: 26px;
        line-height: 98px;
        text-align: center;
        cursor: pointer;
        background-color: #ECF8FF;
        border-bottom-width: 0;
        &:first-child {
          border-right-width: 0;
        }
        &:last-child {
          border-left-width: 0;
        }
        &.active {
          background-image: url("~@/assets/images/guidance/m_btn.png");
          background-repeat: no-repeat;
          background-position: left top;
          background-size: 100% 100%;
          border-width: 0;
          color: #ffffff;
        }
      }
    }
    .guidance-des {
      text-align: center;
      line-height: 26px;
      padding-top: 32px;
      padding-bottom: 20px;
      color: rgba(51, 51, 51, 0.6);
    }
    .guidance-form-btn {
      width: 100%;
      height: 80px;
      background: #008CE0;
      border: 1px solid #008CE0;
      text-align: center;
      line-height: 88px;
      color:#ffffff;
      cursor: pointer;
      border-radius: 8px;
      margin-bottom: 6px;
      &.disabled {
        background-color: #fff;
        border-color: #ebeef5;
        color: #c0c4cc;
        cursor: not-allowed;
      }
    }
    .guidance-cards {
      text-align: center;
      line-height: 42px;
      padding-bottom: 47px;
      .guidance-cards-label {
        padding-bottom: 14px;
      }
      .guidance-cards-des {
        color: #7C7C7C;
        font-size: 22px;
      }
    }
  }
}
</style>
